// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.meeting-auditor-root {
    display: flex;
    flex-direction: column;
    width: 404px;
    height: calc(100vh - 40px);
    border-radius: 10px;
    background: #F9F9F9;
    position: fixed;
    top: 20px;
    left: 20px;
}

.meeting-auditor-header {
    width: 404px;
    height: 60px;
    border-radius: 10px 10px 0px 0px;
    background: #4DA648;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.meeting-auditor-heading {
    display: flex;
    align-items: center;
    margin-left: 10px;
}

.meeting-auditor-heading-text {
    margin-left: 16px;color: #FFF;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 31px;
}

.meeting-auditor-heading-close {
    margin-left: 182px;
}

.meeting-auditor-notes-container {
    height: calc(100vh - 100px);
    overflow-y: scroll;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}

.meeting-auditor-notes-container::-webkit-scrollbar {
    display: none;
}

.meeting-auditor-bubble-container {
    display: flex;
    width: 384px;
    padding: 13.689px 0px 13.689px 14px;
    flex-direction: column;
    align-items: flex-start;
    gap: 10.53px;
    flex-shrink: 0;
    border-radius: 10px;
    border: 1.053px solid #D2D2D2;
    background: #FFF;
    box-sizing: border-box;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 8px;
}

.meeting-auditor-bubble-container-note {
    height: 182px;
}

.meeting-auditor-create-note-text {
    color: #757575;
    font-family: Nunito Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    width: 100%;
    cursor: pointer;
    display: flex;
}

.meeting-auditor-note-title-container {
    display: flex;
    align-items: center;
}

.meeting-auditor-note-title-text {
    color: #757575;
    font-family: Nunito Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.meeting-auditor-note-edit-icon,
.meeting-auditor-note-delete-icon {
    margin-left: 299px;
}

.meeting-auditor-note-content {
    width: 357px;
    border: none;
    color: #5A5A5A;
    font-family: Nunito Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 23px;
    height: 115px;
    overflow-y: scroll;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
    display: flex;
    overflow-wrap: anywhere;
    text-wrap: wrap;
    text-align: start;
}

.meeting-auditor-note-content::-webkit-scrollbar {
    display: none;
}

.meeting-auditor-note-edit-content {
    width: 357px;
    border: none;
    color: #5A5A5A;
    font-family: Nunito Sans!important;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 23px;
    height: 85px;
    overflow-y: scroll;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}

.meeting-auditor-note-edit-content::-webkit-scrollbar {
    display: none;
}

.meeting-auditor-delete-note {
    width: 75px;
    height: 24px;
    padding: 5.942px 0px;
    border-radius: 3.541px;
    background: #E63945;
    color: #FFF;
    font-size: 9.443px;
    font-style: normal;
    font-weight: 700;
    line-height: 11.885px;
    margin-right: 5px;
    margin-bottom: 10px;
    border: none;
}

.meeting-auditor-save-note {
    width: 75px;
    height: 24px;
    padding: 5.942px 0px;
    border-radius: 3.541px;
    background: #4DA648;
    color: #FFF;
    font-size: 9.443px;
    font-style: normal;
    font-weight: 700;
    line-height: 11.885px;
    margin-right: 10px;
    margin-bottom: 10px;
    border: none;
}

`, "",{"version":3,"sources":["webpack://./react/11sight/features/meeting-auditor/notes-component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gCAAgC;IAChC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB,CAAC,WAAW;IAC7B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,wBAAwB,GAAG,gBAAgB;IAC3C,qBAAqB,GAAG,YAAY;AACxC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mCAAmC;IACnC,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,wBAAwB,GAAG,gBAAgB;IAC3C,qBAAqB,GAAG,YAAY;IACpC,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,wBAAwB,GAAG,gBAAgB;IAC3C,qBAAqB,GAAG,YAAY;AACxC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":[".meeting-auditor-root {\n    display: flex;\n    flex-direction: column;\n    width: 404px;\n    height: calc(100vh - 40px);\n    border-radius: 10px;\n    background: #F9F9F9;\n    position: fixed;\n    top: 20px;\n    left: 20px;\n}\n\n.meeting-auditor-header {\n    width: 404px;\n    height: 60px;\n    border-radius: 10px 10px 0px 0px;\n    background: #4DA648;\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.meeting-auditor-heading {\n    display: flex;\n    align-items: center;\n    margin-left: 10px;\n}\n\n.meeting-auditor-heading-text {\n    margin-left: 16px;color: #FFF;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 31px;\n}\n\n.meeting-auditor-heading-close {\n    margin-left: 182px;\n}\n\n.meeting-auditor-notes-container {\n    height: calc(100vh - 100px);\n    overflow-y: scroll;\n    -ms-overflow-style: none;  /* IE and Edge */\n    scrollbar-width: none;  /* Firefox */\n}\n\n.meeting-auditor-notes-container::-webkit-scrollbar {\n    display: none;\n}\n\n.meeting-auditor-bubble-container {\n    display: flex;\n    width: 384px;\n    padding: 13.689px 0px 13.689px 14px;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10.53px;\n    flex-shrink: 0;\n    border-radius: 10px;\n    border: 1.053px solid #D2D2D2;\n    background: #FFF;\n    box-sizing: border-box;\n    margin-left: 10px;\n    margin-right: 10px;\n    margin-bottom: 8px;\n}\n\n.meeting-auditor-bubble-container-note {\n    height: 182px;\n}\n\n.meeting-auditor-create-note-text {\n    color: #757575;\n    font-family: Nunito Sans;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    width: 100%;\n    cursor: pointer;\n    display: flex;\n}\n\n.meeting-auditor-note-title-container {\n    display: flex;\n    align-items: center;\n}\n\n.meeting-auditor-note-title-text {\n    color: #757575;\n    font-family: Nunito Sans;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n}\n\n.meeting-auditor-note-edit-icon,\n.meeting-auditor-note-delete-icon {\n    margin-left: 299px;\n}\n\n.meeting-auditor-note-content {\n    width: 357px;\n    border: none;\n    color: #5A5A5A;\n    font-family: Nunito Sans;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 23px;\n    height: 115px;\n    overflow-y: scroll;\n    -ms-overflow-style: none;  /* IE and Edge */\n    scrollbar-width: none;  /* Firefox */\n    display: flex;\n    overflow-wrap: anywhere;\n    text-wrap: wrap;\n    text-align: start;\n}\n\n.meeting-auditor-note-content::-webkit-scrollbar {\n    display: none;\n}\n\n.meeting-auditor-note-edit-content {\n    width: 357px;\n    border: none;\n    color: #5A5A5A;\n    font-family: Nunito Sans!important;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 23px;\n    height: 85px;\n    overflow-y: scroll;\n    -ms-overflow-style: none;  /* IE and Edge */\n    scrollbar-width: none;  /* Firefox */\n}\n\n.meeting-auditor-note-edit-content::-webkit-scrollbar {\n    display: none;\n}\n\n.meeting-auditor-delete-note {\n    width: 75px;\n    height: 24px;\n    padding: 5.942px 0px;\n    border-radius: 3.541px;\n    background: #E63945;\n    color: #FFF;\n    font-size: 9.443px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 11.885px;\n    margin-right: 5px;\n    margin-bottom: 10px;\n    border: none;\n}\n\n.meeting-auditor-save-note {\n    width: 75px;\n    height: 24px;\n    padding: 5.942px 0px;\n    border-radius: 3.541px;\n    background: #4DA648;\n    color: #FFF;\n    font-size: 9.443px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 11.885px;\n    margin-right: 10px;\n    margin-bottom: 10px;\n    border: none;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
